import React from 'react'
import { Box, Dialog, Slide, Typography } from '@mui/material'
import { useTheme } from '@mui/styles'

import WaitingForPlayers from 'core/waiting-players/WaitingForPlayers'
import Button from 'core/buttons/Button'
import { useGameMode } from 'providers/GameMode'
import Spinner from 'core/Spinner'
import { useNavigate } from 'react-router-dom'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const WaitingScreen = ({ open, setOpen, wine, players, loading }) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const handleClose = () => { setOpen(!open) }
  const { player } = useGameMode()
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', m: 'auto', height: '100%' }}>
      <Dialog
        fullScreen={theme.popUpsWidth}
        sx={{
          display: 'flex',
          width: '100vw',
          maxWidth: '450px',
          m: 'auto',

          '.MuiBackdrop-root': {
            width: '100vw',
            maxWidth: '450px',
            m: 'auto'
          },
          '.MuiDialog-container': {
            display: 'flex',
            alignItems: 'flex-end'
          },
          '.MuiPaper-root': {
            width: '100vw',
            maxWidth: '450px',
            bgcolor: '#fffdf7'

          },
          '.MuiDialog-paper::-webkit-scrollbar': {
            display: 'none'
          }
        }}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >

        <Box component="img" src="/background.svg" alt="" sx={{ position: 'absolute', width: '100%', height: 1, minHeight: 750, overflowY: 'hidden' }} />
        <Box sx={{
          zIndex: 10,
          height: 1,
          minHeight: 750,
          position: 'relative',
          overFlowY: 'hidden',
          background: 'linear-gradient(to bottom, rgba(255,253,247,0), rgb(250,243,237))'
        }}>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', height: 1, minHeight: 750 }}>
            <Typography fontFamily="KaiseiDecolBold" fontSize={18} sx={{ pt: 10, pb: 4, mx: 4, textAlign: 'center' }}>{wine.name}</Typography>
            <Box sx={{ width: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <WaitingForPlayers players={players} content="We are waiting for all players to score the wine" />
            </Box>
            <Box sx={{ p: 2, width: 1 }}>
              {
                player?.isHost
                  ? <Button disabled={loading} sx={{ borderColor: loading && 'gray' }} onClick={() => navigate('/game-room')}>
                      {
                        loading
                          ? <Spinner />
                          : <Typography fontFamily="DMSansRegular" fontWeight={700} fontSize={18}>
                              View Game Lobby
                            </Typography>
                      }
                    </Button>
                  : null
              }
            </Box>
        </Box>

        </Box>
      </Dialog>
    </Box>
  )
}

export default WaitingScreen
